var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    !_vm.initialized
      ? _c("h4", [
          _c("i", { staticClass: "fa fa-spinner fa-spin" }),
          _vm._v(" Checking dependencies...\n    "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.initialized
      ? _c("div", [
          _vm.reports.length > 0
            ? _c("div", { staticClass: "card mt-3" }, [
                _c("div", { staticClass: "card-header" }, [
                  _vm._v(
                    "\n                Reports (" +
                      _vm._s(_vm.reports.length) +
                      ")\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "list-group list-group-flush" },
                  _vm._l(_vm.reports, function (r) {
                    return _c(
                      "li",
                      { key: r.Id, staticClass: "list-group-item" },
                      [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: _vm.url_ReportViewPage(r),
                                expression: "url_ReportViewPage(r)",
                              },
                            ],
                            staticClass: "text-primary",
                            attrs: { target: "_blank" },
                          },
                          [_vm._v(_vm._s(r.Name))]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.lists.length > 0
            ? _c("div", { staticClass: "card mt-3" }, [
                _c("div", { staticClass: "card-header" }, [
                  _vm._v(
                    "\n                Lists (" +
                      _vm._s(_vm.lists.length) +
                      ")\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "list-group list-group-flush" },
                  _vm._l(_vm.lists, function (l) {
                    return _c(
                      "li",
                      { key: l.Id, staticClass: "list-group-item" },
                      [_c("span", [_vm._v(_vm._s(l.Name))])]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.estimationsSurveys.length > 0
            ? _c("div", { staticClass: "card mt-3" }, [
                _c("div", { staticClass: "card-header" }, [
                  _vm._v(
                    "\n                Assessments (" +
                      _vm._s(_vm.estimationsSurveys.length) +
                      ")\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "list-group list-group-flush" },
                  _vm._l(_vm.estimationsSurveys, function (s) {
                    return _c(
                      "li",
                      { key: s.Id, staticClass: "list-group-item" },
                      [_c("span", [_vm._v(_vm._s(s.Name))])]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }